export const POST_CLICK_PURCHASES = 14
